module.exports = __webpack_public_path__ + "media/images/icons/outlined/like-c9932bb0f76da4e18f002e02b5850e5e.svg";